import { ToastContainer, ToastContainerProps, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./ToastMessage.module.scss";
import info from "../../assets/images/icons/ui/states/alert-blue-icon.svg";
import success from "../../assets/images/icons/ui/states/success-inverted-filled-icon.svg";
import warning from "../../assets/images/icons/ui/states/alert-blue-icon.svg";
import error from "../../assets/images/icons/ui/states/alert-icon.svg";

interface ToastMessageProps extends ToastContainerProps {
  messageId: string;
  width?: string;
  className?: string;
  toastClassName?: string;
}

const ToastMessage = (props: ToastMessageProps) => {
  const { messageId, width, className, toastClassName, position, ...rest } =
    props;

  const { container, toast, icon } = styles;

  return (
    <ToastContainer
      position={position ?? "top-center"}
      containerId={messageId}
      transition={Slide}
      className={`${className} ${container}`}
      toastClassName={`${toastClassName} ${toast}`}
      icon={({ type }) =>
        ({
          info: <img src={info} className={icon} />,
          error: <img src={error} className={icon} />,
          warning: <img src={warning} className={icon} />,
          success: <img src={success} className={icon} />,
          default: <img src={info} className={icon} />,
        }[type])
      }
      {...rest}
    />
  );
};

export default ToastMessage;
